<template>
  <div>
    <div v-if="videos">
      <div class="results results_theme_many-elems form__results_block_result">
        <div
          class="results__video-container"
          v-for="video in videos"
          :key="video.url"
        >
          <img
            class="results__image results__image_alt"
            rel="preload"
            :src="video.img"
            :alt="video.title"
          >
          <div class="results__description-block">
            <h4 class="results__title">{{ video.title }}</h4>
          </div>
          <button
            type="button"
            class="results__btn-download"
            @click.prevent="sendToForm(video.url)"
          >
            <img
              src="/images/form/download.svg"
              alt="arrow down"
              width="16px"
              height="16px"
            >
            <p>Download</p>
          </button>
        </div>
      </div>
    </div>
    <div v-if="searchUrlInsPosts != null && isInstagram">
      <div class="results__switch-container">
        <div class="results__tabs">
          <button
            class="results__tab results__tab_alt"
            v-bind:class="{ 'results__tab_active': activBtn === 'stories' }"
            @click="activePage('stories')"
            type="button"
          >
            <span>Stories</span>
          </button>
          <button
            class="results__tab results__tab_alt"
            v-bind:class="{ 'results__tab_active': activBtn === 'posts' }"
            @click="activePage('posts')"
            type="button"
          >
            <span>Posts</span>
          </button>
        </div>
      </div>
      <main-results
        v-if="activBtn == 'posts' && searchUrlInsPosts !== null" :activBtn="activBtn"
        :searchUrlInsPosts="searchUrlInsPosts"
        :key="'posts'"
      >
      </main-results>
      <main-results
        v-if="activBtn == 'stories' && searchUrlInsStories !== null"
        :activBtn="activBtn"
        :searchUrlInsStories="searchUrlInsStories"
        :key="'stories'"
      >
      </main-results>
      <div v-if="error">
        <ErrorBlock />
      </div>
    </div>
  </div>
</template>

<script>
import getCookie from "../tools/getCookie";
import axios from "axios";
import ErrorBlock from "./ErrorBlock";
import MainResults from './MainResults.vue'; // posts // stories

export default {
  components: {
    ErrorBlock,
    MainResults,
  },
  props: ["canonical"],
  data() {
    return {
      videos: null,
      error: null,
      activBtn: null,
      isInstagram: null,
      searchUrlInsPosts: null,
      searchUrlInsStories: null,
      input: null,
      urlAddress: -1,
    }
  },
  mounted() {
    this.$root.$on('clear-results', () => {
      this.videos = null;
      this.error = null;
    });
    this.$root.$on('search-request', (string) => {
      if (string === null) {
        this.searchUrlInsPosts = null;
        this.searchUrlInsStories = null;
        this.input = null;
      } else {
        this.searchRequest(string)
      }
    });
  },
  methods: {
    handleError(result) {
      this.$root.$emit('show-error', result, this.link);
      this.error = true;
    },
    searchRequest(string) {
      this.isInstagram = window?.location.pathname?.includes('instagram') || window?.location?.href.includes('instagram')
      this.urlAddress = string.search(/^http|^https:\/\/|^www\.|^instagram\.com|instagr\.am/gi)
      if (this.isInstagram && !string.search(/^[a-z@]/gi)) {
        if (string[0] === "@") {
          this.input = string.substring(1)
        } else if (this.urlAddress >= 0) {
          string = string.trim().match(/[\d\w-_.]+\/?$/gims)[0];
          if (string[string.length - 1] === '/') {
            string = string.substring(0, string.length - 1)
          }
          this.input = string;
        } else {
          this.input = string;
        }
        this.activePage()
      } else {

        document.getElementById('main-form').scrollIntoView();
        const data = {
          query: string,
        };

        document.getElementById('loader').style.display = null;

        axios.post('/search/', data, {
          headers: {
            'X-CSRFToken': getCookie('csrftoken'),
            'X-Requested-With': 'XMLHttpRequest',
          },
        }).then((success) => {
          this.videos = success.data.links;
        }).catch((error) => {
          console.log(error);
        }).finally(()=>{
          document.getElementById('loader').style.display = "none";
        });
      }
    },
    sendToForm(url) {
      this.$root.$emit('search-download', url);
      localStorage.setItem("search", url);
      window.open(this.canonical);
    },
    download(link) {
      this.$root.$emit('download-click', this.link, 'mp4');
      setTimeout(() => {
        document.location = link;
      }, 500);
    },
    activePage(page = 'posts') {
      this.activBtn !== page ? this.activBtn = page : '';
      if (this.input) {
        this.searchUrlInsPosts = `https://www.instagram.com/${this.input}/`;
        this.searchUrlInsStories = `https://www.instagram.com/stories/${this.input}/`;
      }
    },
  }
}
</script>
